<template lang="html">
  <div class="table_card">
    <div class="table_card__head">
      <v-layout row wrap>
        <v-flex lg9>
          <p class="table_card__head--title">Nuevo segmento</p>
          <v-breadcrumbs class="breadcums">
            <v-icon slot="divider">chevron_right</v-icon>
            <v-breadcrumbs-item
              @click="$router.push({name: 'condition'})"
              class="breadcums__option"
            >
              Segmentos
            </v-breadcrumbs-item>
            <v-breadcrumbs-item
              disabled
              class="breadcums__disable"
            >
              Nuevo segmento
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-flex>
        <v-flex lg3 class="filter_options">
          <v-flex class="right mr-1">
            <button
              class="faccess_button px-5"
              @click="createCondition()"
            >
                Crear
            </button>
          </v-flex>
        </v-flex>
      </v-layout>
    </div>
    <div class="table_card__body">
      <section>
        <div class="offer_elements__condition--new_info_container">
          <p class="agreement__text--small_gray">Descripción</p>
          <v-text-field
            single-line
            name="name"
            label="Descripción del segmento"
            type="text"
            v-model="condition.attributes.description"></v-text-field>
          <!-- <v-flex xs12>
            <v-btn
              color="#EC7E00"
              dark
              @click="addRequirement()">Agregar requerimiento</v-btn>
            </v-flex> -->
          <div class="offer_elements__condition--element_container">
            <div class="offer_elements__condition--requirement" v-for="(requirement, index) in requirements">
              <p class="agreement__text--small_gray">Requerimiento</p>
              <div class="offer_elements__condition--action_row_requirement">
                <div class="dashboard__options--input with_box_shadow offer_elements__condition--select"
                  @click="requirement.modal=!requirement.modal" style="width:69%">
                  <p >{{requirement.selectedOption!=''?requirement.selectedOption:'Selecciona'}}</p>
                  <img  src="https://s3-us-west-2.amazonaws.com/karrottsportlife/arrow_down.svg">
                  <div v-if="requirement.modal" class="offer_elements__condition--options">
                    <template v-for="option in requirement.options">
                      <v-hover>
                        <div slot-scope="{ hover }" @click="changeBooleanState(index,option)" :class="hover?'offer_elements__interaction--hover':''" class="offer_elements__condition--options_item" >
                          <p>{{option.text}}</p>
                        </div>
                      </v-hover>
                    </template>
                  </div>
                </div>
                <v-hover>
                  <button  @click="removeRequirement(index)" slot-scope="{ hover }" :class="hover?'offer_elements__interaction--hover_delete':''" class="offer_elements__button--add_requirement with_box_shadow offer_elements__interaction--border_gray">
                    <div class="offer_elements__button--delete_requirement " :class="hover?'offer_elements__interaction--hover_delete_background':''">
                      <p>x</p>
                    </div>
                  </button>
                </v-hover>
              </div>
              <!-- <v-switch
                :label="`¿Es un requerimiento por visitas?: ${requirement.requirement_query ? 'Si' : 'No'}`"
                v-model="requirement.requirement_query"
                v-if="requirement.requirement_query ||
                      (requirement.requirement_range == false &&
                        requirement.requirement_email == false &&
                        requirement.requirement_register == false &&
                        requirement.requirement_birthday == false &&
                        requirement.requirement_redemption == false)"
                ></v-switch> -->
              <v-flex xs12 sm12 v-if="requirement.requirement_query">
                <p class="agreement__text--small_gray">Descripción</p>
                <v-text-field
                  single-line
                  name="name"
                  label="Descripción del requerimiento"
                  type="text"
                  v-model="requirement.query_attributes.attribute_json.description"></v-text-field>
                <p class="agreement__text--small_gray">Tipo de modelo</p>
                <v-select
                  v-model="requirement.query_attributes.attribute_json.object_type"
                  :items="requirement.query_types"
                  item-text="text"
                  label="Tipo de modelo"
                  persistent-hint
                  return-object
                  single-line
                  @change="findObjects(index)"
                  ></v-select>
                <v-flex xs12 v-if="requirement.objects.length > 0">
                  <v-switch
                    :label="`¿Tiene una localidad en específico?: ${requirement.requirement_visit_location ? 'Si' : 'No'}`"
                    v-model="requirement.requirement_visit_location"
                    v-if="requirement.query_attributes.attribute_json.object_type.type =='Location'"
                    ></v-switch>
                  <template v-if="requirement.query_attributes.attribute_json.object_type.type == 'Offer'||(requirement.query_attributes.attribute_json.object_type.type =='Location'&&requirement.requirement_visit_location)">
                    <p class="agreement__text--small_gray">Opciones</p>
                    <v-select
                      v-model="requirement.query_attributes.attribute_json.object_id"
                      :items="requirement.objects"
                      item-text="attributes.title"
                      label="Tipo de modelo"
                      persistent-hint
                      return-object
                      single-line
                      ></v-select>
                  </template>
                </v-flex>
                <p class="agreement__text--small_gray">Visitas</p>
                <v-text-field
                  name="visits"
                  label="Visitas a la instancia del modelo"
                  type="number"
                  single-line
                  v-model="requirement.query_attributes.attribute_json.times"></v-text-field>
              </v-flex>
              <!-- <v-switch
                :label="`¿Incluir un requerimiento por rango?: ${requirement.requirement_range ? 'Si' : 'No' }`"
                v-model="requirement.requirement_range"
                v-if="requirement.requirement_range ||
                      (requirement.requirement_query == false &&
                        requirement.requirement_email == false &&
                        requirement.requirement_register == false &&
                        requirement.requirement_birthday == false &&
                        requirement.requirement_redemption == false)"
                ></v-switch> -->
              <v-flex xs12 v-if="requirement.requirement_range">
                <p class="agreement__text--small_gray">Descripción</p>
                <v-text-field
                  name="name"
                  label="Descripción del requerimiento"
                  type="text"
                  single-line
                  v-model="requirement.range_attributes.attribute_json.description"></v-text-field>
                <v-flex xs12>
                  <p class="agreement__text--small_gray">Opción</p>
                  <v-select
                    v-model="requirement.range_attributes.attribute_json.attribute_name"
                    :items="requirement.range_type_attribute"
                    item-text="text"
                    label="Nombre de atributo del cliente"
                    persistent-hint
                    return-object
                    single-line
                    ></v-select>
                </v-flex>
                <v-layout xs12 row wrap>
                  <v-flex
                    xs6
                    style="padding: 8px"
                    v-if="requirement.range_attributes.attribute_json.attribute_name != ''">
                    <p class="agreement__text--small_gray">Desde</p>
                    <v-text-field
                      name="number"
                      label=""
                      type="number"
                      v-model="requirement.range_attributes.attribute_json.lower_bound"
                      v-if="requirement.range_attributes.attribute_json.attribute_name.attribute == 'age'"></v-text-field>
                    <v-menu
                      v-model="requirement.requirement_date_menu"
                      :nudge-bottom="10"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      v-else-if="requirement.range_attributes.attribute_json.attribute_name.attribute == 'created_at' || requirement.range_attributes.attribute_json.attribute_name.attribute == 'updated_at'"
                      >
                      <template v-slot:activator="{ on }">
                        <div  class="date_picker__selector--invitation" v-on="on" >
                          <p >{{requirement.range_attributes.attribute_json.lower_bound!=null?requirement.range_attributes.attribute_json.lower_bound:'Seleccione una fecha'}}</p>
                          <img :src="requirement.requirement_date_menu ?'https://s3-us-west-2.amazonaws.com/karrottsportlife/arrow_up.svg':'https://s3-us-west-2.amazonaws.com/karrottsportlife/arrow_down.svg'">
                        </div>
                      </template>
                      <v-date-picker
                        v-model="requirement.range_attributes.attribute_json.lower_bound"
                        locale="es"
                        color="#EC7E00"
                        scrollable
                        ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex
                    xs6
                    style="padding: 8px; "
                    v-if="requirement.range_attributes.attribute_json.attribute_name != ''">
                    <p class="agreement__text--small_gray">Hasta</p>
                    <v-text-field
                      name="number"
                      label=""
                      type="number"
                      v-model="requirement.range_attributes.attribute_json.upper_bound"
                      v-if="requirement.range_attributes.attribute_json.attribute_name.attribute == 'age'"></v-text-field>
                    <v-menu
                      v-model="requirement.requirement_date_menu2"
                      :nudge-bottom="10"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      v-else-if="requirement.range_attributes.attribute_json.attribute_name.attribute == 'created_at' || requirement.range_attributes.attribute_json.attribute_name.attribute == 'updated_at'"
                      >
                      <template v-slot:activator="{ on }">
                        <div  class="date_picker__selector--invitation" v-on="on" >
                          <p >{{requirement.range_attributes.attribute_json.upper_bound!=null?requirement.range_attributes.attribute_json.upper_bound:'Seleccione una fecha'}}</p>
                          <img :src="requirement.requirement_date_menu2 ?'https://s3-us-west-2.amazonaws.com/karrottsportlife/arrow_up.svg':'https://s3-us-west-2.amazonaws.com/karrottsportlife/arrow_down.svg'">
                        </div>
                      </template>
                      <v-date-picker
                        v-model="requirement.range_attributes.attribute_json.upper_bound"
                        locale="es"
                        color="#EC7E00"
                        scrollable
                        ></v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
              </v-flex>
              <!-- <v-switch
                :label="`¿Es un requerimiento con emails?: ${requirement.requirement_email ? 'Si' : 'No' }`"
                v-model="requirement.requirement_email"
                v-if="requirement.requirement_email ||
                      (requirement.requirement_query == false &&
                        requirement.requirement_range == false &&
                        requirement.requirement_register == false &&
                        requirement.requirement_birthday == false &&
                        requirement.requirement_redemption == false)"
                ></v-switch> -->
              <v-flex xs12 v-if="requirement.requirement_email">
                <p class="agreement__text--small_gray">Emails</p>
                <v-text-field
                  name="emails"
                  label="Ingrese los emails, separados por comas"
                  type="text"
                  single-line
                  v-model="requirement.email_attributes.attribute_json.emails"></v-text-field>
              </v-flex>
              <!-- <v-switch
                :label="`¿Es un requerimiento por registro?: ${requirement.requirement_register ? 'Si' : 'No' }`"
                v-model="requirement.requirement_register"
                v-if="requirement.requirement_register ||
                      (requirement.requirement_query == false &&
                        requirement.requirement_range == false &&
                        requirement.requirement_email == false &&
                        requirement.requirement_birthday == false &&
                        requirement.requirement_redemption == false)"
                ></v-switch> -->
              <v-flex xs12 v-if="requirement.requirement_register">
              </v-flex>
              <!-- <v-switch
                :label="`¿Es un requerimiento por cumpleaños?: ${requirement.requirement_birthday ? 'Si' : 'No' }`"
                v-model="requirement.requirement_birthday"
                v-if="requirement.requirement_birthday ||
                      (requirement.requirement_query == false &&
                        requirement.requirement_range == false &&
                        requirement.requirement_email == false &&
                        requirement.requirement_register == false &&
                        requirement.requirement_redemption == false)"
                ></v-switch> -->
              <v-flex xs12 sm12  v-if="requirement.requirement_birthday">
                <p class="agreement__text--small_gray">Seleccione el mes </p>
                <v-select
                  :items="months"
                  v-model="requirement.birthday_attributes.attribute_json.value"
                  single-line
                  label="Selecciona el mes de cumpleaños"
                  ></v-select>
              </v-flex>
              <!-- <v-switch
                :label="`¿Es un requerimiento por canje de ofertas?: ${requirement.requirement_redemption ? 'Si' : 'No'}`"
                v-model="requirement.requirement_redemption"
                v-if="requirement.requirement_redemption ||
                      (requirement.requirement_query == false &&
                        requirement.requirement_range == false &&
                        requirement.requirement_email == false &&
                        requirement.requirement_register == false &&
                        requirement.requirement_birthday == false)"
                ></v-switch> -->
              <v-flex xs12 sm12 v-if="requirement.requirement_redemption">
                <v-flex xs12>
                  <p class="agreement__text--small_gray">Descripción</p>
                  <v-text-field
                    name="name"
                    label="Descripción del requerimiento"
                    type="text"
                    single-line
                    v-model="requirement.redemption_attributes.attribute_json.description"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <p class="agreement__text--small_gray">Nombre de la oferta</p>
                  <v-select
                    v-model="requirement.redemption_attributes.attribute_json.object_id"
                    :items="requirement.redemption_offers_options"
                    item-text="attributes.title"
                    label="Oferta a canjear"
                    persistent-hint
                    return-object
                    single-line
                    ></v-select>
                </v-flex>
                <v-flex xs12>
                  <p class="agreement__text--small_gray">Número de canjes</p>
                  <v-text-field
                    name="visits"
                    label="Número de canjes de la oferta"
                    type="number"
                    single-line
                    v-model="requirement.redemption_attributes.attribute_json.times"></v-text-field>
                </v-flex>
              </v-flex>
              <v-flex xs12 sm12 v-if="requirement.requirement_event_count">
                <p class="agreement__text--small_gray">Cantidad de eventos enviados</p>
                <v-text-field
                  name="event_count"
                  label="Numero de evnetos enviados"
                  type="number"
                  single-line
                  v-model="requirement.event_count_attributes.attribute_json.times"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 v-if="requirement.requirement_characteristic">
                <v-flex xs12>
                  <p class="agreement__text--small_gray">Nombre de la característica</p>
                  <v-select
                    v-model="requirement.characteristic_attributes.attribute_json.characteristic_id"
                    :items="requirement.characteristic_options"
                    :item-text="optionName"
                    label="Nombre de la característica"
                    persistent-hint
                    return-object
                    single-line
                    @change="searchCharacteristicValue(requirement);requirement.characteristic_attributes.attribute_json.characteristic_value_id={'id':null, name:null}"
                    ></v-select>
                </v-flex>
                <v-flex xs12>
                  <p class="agreement__text--small_gray">Valor de la característica requerido</p>
                  <v-select
                    v-model="requirement.characteristic_attributes.attribute_json.characteristic_value_id"
                    :items="requirement.characteristic_values_options"
                    :item-text="optionName"
                    label="Valor de la característica"
                    persistent-hint
                    return-object
                    single-line
                    ></v-select>
                </v-flex>
                <v-flex xs12 v-if="requirement.characteristic_attributes.attribute_json.characteristic_value_id && requirement.characteristic_attributes.attribute_json.characteristic_value_id.id=='0'">
                  <p class="agreement__text--small_gray">Rango de valores personalizados</p>
                  <v-card-text  style="margin-top:-21px;">
                    <v-flex style="display:flex;">
                      <p class="data_card__info--title" style="font-size:12px;margin-top:16px;width:60px;padding:12px;height:fit-content;padding-right:0px;margin-left:10px">Desde</p>
                      <v-flex class="px-2"></v-flex>
                      <p class="data_card__info--title" style="font-size:12px;margin-top:16px;width:fit-content;padding:12px;height:fit-content; padding-right:50px; ">Hasta</p>
                    </v-flex>
                    <v-layout >
                      <v-flex class="px-4" style="margin-top:-21px;">
                        <v-range-slider
                          v-model="requirement.characteristic_attributes.attribute_json.custom_querry"
                          :max="requirement.characteristic_attributes.attribute_json.characteristic_id.maxRange"
                          :smin="0"
                          :step="sliderStep(requirement.characteristic_attributes.attribute_json.characteristic_id.maxRange)"
                          hide-details
                          class="align-center"
                          type="decimal"
                          >
                          <template v-slot:prepend>
                            <v-text-field
                              v-model="requirement.characteristic_attributes.attribute_json.custom_querry[0]"
                              class="mt-0 pt-0"
                              hide-details
                              single-line
                              type="float"
                              style="width: 100px"
                              ></v-text-field>
                          </template>
                          <template v-slot:append>
                            <v-text-field
                              v-model="requirement.characteristic_attributes.attribute_json.custom_querry[1]"
                              class="mt-0 pt-0"
                              hide-details
                              single-line
                              type="float"
                              style="width: 100px"
                              ></v-text-field>
                          </template>
                        </v-range-slider>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-flex>
              </v-flex>
              <v-spacer></v-spacer>
              <!-- <v-layout align-center justify-end row fill-height>
                <v-btn
                  color="red lighten-1"
                  dark
                  @click="removeRequirement(index)">Eliminar Requerimiento</v-btn>
                </v-layout> -->
            </div>
            <v-flex xs6>
              <p class="agreement__text--small_gray ">Requerimiento</p>
              <div class="offer_elements__condition--add_container  ">
                <v-hover>
                  <button @click="addRequirement()" slot-scope="{ hover }" :class="hover?'accessIndex__interaction--hover_add':''" class="offer_elements__button--add_requirement with_box_shadow offer_elements__interaction--border_blue">
                    +
                  </button>
                </v-hover>
              </div>
            </v-flex >
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      condition: {
        attributes: {
          description: "",
          frequent: true,
          requirements_attributes: [],
          company_id: this.getCompany().id,
        },
      },
      months: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      requirements: [],
      myCharacteristicsOptions: [],
    };
  },
  mounted() {
    this.findCategories();
    this.findLocations();
    this.findOffers();
    this.getCharacteristics();
  },
  methods: {
    optionName(item){
     return item.name.charAt(0).toUpperCase() + item.name.slice(1)
    },
    removeRequirement(index) {
      this.requirements.splice(index, 1);
    },
    addRequirement() {
      var requirement = {
        objects: [],
        requirement_query: false,
        requirement_range: false,
        requirement_email: false,
        requirement_birthday: false,
        requirement_register: false,
        requirement_redemption: false,
        requirement_visit_location: false,
        requirement_date_menu: false,
        requirement_date_menu2: false,
        requirement_characteristic: false,
        requirement_event_count: false,
        selectedOption: "",
        modal: false,
        options: [
          {
            text: "Requerimiento por visitas",
            boolean: "requirement_query",
          },
          {
            text: "Requerimiento por rango",
            boolean: "requirement_range",
          },
          {
            text: "Requerimiento por emails",
            boolean: "requirement_email",
          },
          {
            text: "Requerimiento por registro",
            boolean: "requirement_register",
          },
          {
            text: "Requerimiento por cumpleaños",
            boolean: "requirement_birthday",
          },
          {
            text: "Requerimiento por canje de ofertas",
            boolean: "requirement_redemption",
          },
          {
            text: "Requerimiento por eventos de comunidad",
            boolean: "requirement_event_count",
          },
          {
            text: "Requerimiento por característica de usuario",
            boolean: "requirement_characteristic",
          }
        ],
        query_types: [
          {
            text: "Locación",
            type: "Location",
          },
          {
            text: "Oferta",
            type: "Offer",
          },
        ],
        range_types: [
          {
            text: "Fecha",
            type: "date_time",
          },
          {
            text: "Numero",
            type: "integer",
          },
          {
            text: "Flotante",
            type: "float",
          },
        ],
        range_type_attribute: [
          {
            text: "Fecha de creación de la cuenta",
            attribute: "created_at",
          },
          {
            text: "Edad",
            attribute: "age",
          },
          {
            text: "Modificación de la cuenta",
            attribute: "updated_at",
          },
        ],
        query_attributes: {
          type: "ControllerQuery",
          attribute_json: {
            object_type: "",
            object_id: null,
            description: "",
            times: null,
          },
        },
        range_attributes: {
          type: "RangeQuery",
          attribute_json: {
            lower_bound: null,
            upper_bound: null,
            attribute_type: "",
            description: "",
            class_name: "Client",
            attribute_name: "",
          },
        },
        email_attributes: {
          type: "EmailQuery",
          attribute_json: {
            emails: [],
          },
        },
        register_attributes: {
          type: "RegisterQuery",
          attribute_json: {
            sign_up: "true",
          },
        },
        birthday_attributes: {
          type: "EqualityQuery",
          attribute_json: {
            value: "",
          },
        },
        redemption_attributes: {
          type: "RedemptionQuery",
          attribute_json: {
            object_id: null,
            description: "",
            times: null,
          },
        },
        event_count_attributes: {
          type: "EventCountQuery",
          attribute_json: {
            times: null,
            event_type: "FUSE-ALERT-COM"
          },
        },
        redemption_offers_options: this.getOffers(),
        characteristic_options: this.myCharacteristicsOptions,
        characteristic_values_options: [],
        characteristic_attributes: {
          type: "CharacteristicQuery",
          attribute_json: {
            characteristic_id: null,
            characteristic_value_id: null,
            custom_querry: [0, 1],
            // [{characteristic_id:null,value:null, operator:null}]
          },
        },

        // characteristic_value_options: this.getCharacteristicValues(),
      };
      this.requirements.push(requirement);
    },

    sliderStep(myNumber) {
      var ans = 0;
      if (myNumber <= 10) {
        ans = 0.01;
      } else if (myNumber < 50) {
        ans = 0.1;
      } else {
        ans = 1;
      }
      return ans;
    },
    findObjects(index) {
      if (
        this.requirements[index].query_attributes.attribute_json.object_type
          .type == "Offer"
      ) {
        this.requirements[index].objects = this.getOffers();
      } else if (
        this.requirements[index].query_attributes.attribute_json.object_type
          .type == "Location"
      ) {
        this.requirements[index].objects = this.getLocations();
      } else if (
        this.query_attributes.attribute_json.object_type.type == "Category"
      ) {
        this.requirements[index].objects = this.getCategories();
      } else if (
        this.requirements[index].query_attributes.attribute_json.object_type
          .type == "CharacteristicQuery"
      ) {
        this.requirements[index].objects = this.getCharacteristics();
      }
    },
    createCondition() {
      var vm = this;
      this.condition.attributes.requirements_attributes = [];
      for (var i = 0; i < vm.requirements.length; i++) {
        if (vm.requirements[i].requirement_range) {
          var range_attributes = {
            type: "RangeQuery",
            attribute_json: {
              lower_bound:
                vm.requirements[i].range_attributes.attribute_json.lower_bound,
              upper_bound:
                vm.requirements[i].range_attributes.attribute_json.upper_bound,
              attribute_type:
                vm.requirements[i].range_attributes.attribute_json
                  .attribute_name.attribute == "age"
                  ? "integer"
                  : "date_time",
              description:
                vm.requirements[i].range_attributes.attribute_json.description,
              class_name: "Client",
              attribute_name:
                vm.requirements[i].range_attributes.attribute_json
                  .attribute_name.attribute,
            },
          };
          vm.condition.attributes.requirements_attributes.push(
            range_attributes
          );
        }
        if (vm.requirements[i].requirement_query) {
          var query_attributes = vm.requirements[i].query_attributes;
          query_attributes.attribute_json.object_type =
            vm.requirements[i].query_attributes.attribute_json.object_type.type;
          query_attributes.attribute_json.object_id = vm.requirements[i]
            .query_attributes.attribute_json.object_id
            ? vm.requirements[i].query_attributes.attribute_json.object_id.id
            : null;
          vm.condition.attributes.requirements_attributes.push(
            query_attributes
          );
        }
        if (vm.requirements[i].requirement_email) {
          var email_attributes = vm.requirements[i].email_attributes;
          var format =
            /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/g.test(
              vm.requirements[i].email_attributes.attribute_json.emails
            );
          if (!format) {
            alert("El formato de los correos no coíncide, por favor revisalo");
            vm.condition.attributes.requirements_attributes = [];
          } else {
            email_attributes.attribute_json.emails = vm.requirements[
              i
            ].email_attributes.attribute_json.emails
              .toLowerCase()
              .replace(/\s/g, "")
              .split(",");
            vm.condition.attributes.requirements_attributes.push(
              email_attributes
            );
          }
        }
        if (vm.requirements[i].requirement_register) {
          var register_attributes = vm.requirements[i].register_attributes;
          vm.condition.attributes.requirements_attributes.push(
            register_attributes
          );
        }
        if (vm.requirements[i].requirement_birthday) {
          var birthday_attributes = vm.requirements[i].birthday_attributes;
          birthday_attributes.attribute_json.value =
            vm.months.indexOf(birthday_attributes.attribute_json.value) + 1;
          // cl birthday_attributes.attribute_json.value
          // cl months
          // cl birthday_attributes
          vm.condition.attributes.requirements_attributes.push(
            birthday_attributes
          );
        }
        if (vm.requirements[i].requirement_redemption) {
          var redemption_attributes = vm.requirements[i].redemption_attributes;
          redemption_attributes.attribute_json.object_id =
            vm.requirements[
              i
            ].redemption_attributes.attribute_json.object_id.id;
          vm.condition.attributes.requirements_attributes.push(
            redemption_attributes
          );
        }
        // cl vm.requirements[i].characteristic_attributes.attribute_json
        if (vm.requirements[i].requirement_event_count) {
          var event_count_attributes = vm.requirements[i].event_count_attributes;
          event_count_attributes.attribute_json.times =
            vm.requirements[
              i
            ].event_count_attributes.attribute_json.times;
          vm.condition.attributes.requirements_attributes.push(
            event_count_attributes
          );
        }

        if (vm.requirements[i].requirement_characteristic) {
          var characteristic_attributes = {};
          if (
            vm.requirements[i].characteristic_attributes.attribute_json
              .characteristic_value_id.id != "0"
          ) {
            characteristic_attributes = {
              type: "CharacteristicQuery",
              attribute_json: {
                characteristic_id:
                  vm.requirements[i].characteristic_attributes.attribute_json
                    .characteristic_id.id,
                characteristic_value: {
                  id: vm.requirements[i].characteristic_attributes
                    .attribute_json.characteristic_value_id.id,
                  range:
                    vm.requirements[i].characteristic_attributes.attribute_json
                      .characteristic_value_id.range,
                },
              },
            };
          } else {
            characteristic_attributes = {
              type: "CharacteristicQuery",
              attribute_json: {
                characteristic_id:
                  vm.requirements[i].characteristic_attributes.attribute_json
                    .characteristic_id.id,
                characteristic_value: {
                  id: "0",
                  range: [
                    vm.requirements[i].characteristic_attributes.attribute_json
                      .custom_querry[0],
                    vm.requirements[i].characteristic_attributes.attribute_json
                      .custom_querry[1],
                  ],
                },
              },
            };
          }
          vm.condition.attributes.requirements_attributes.push(
            characteristic_attributes
          );
        }
      }

      if (this.condition.attributes.requirements_attributes.length > 0) {
        if (this.condition.attributes.requirements_attributes.length > 1) {
          this.condition.attributes.frequent = false;
        } else {
          this.condition.attributes.frequent = true;
        }
        try {
          const data = {company: { id: this.getCompany().id }, condition: this.condition}
          this.$http
            .post(
              "conditions",
              {
                data: this.encrypt(data).toString(),
              },
              {
                headers: {
                  "X-Device-ID": this.getDeviceId(),
                  Authorization: "Bearer " + this.getUserToken(),
                },
              }
            )
            .then(
              function (response) {
                this.$router.push({
                  name: "condition",
                });
                if (
                  response.body.meta != undefined &&
                  response.body.meta != null
                ) {
                  if (
                    response.body.meta.authentication_token != undefined &&
                    response.body.meta.authentication_token != null
                  ) {
                    this.checkToken(response.body.meta.authentication_token);
                  }
                }
              },
              function (response) {
                if (
                  response.body.meta != undefined &&
                  response.body.meta != null
                ) {
                  if (
                    response.body.meta.authentication_token != undefined &&
                    response.body.meta.authentication_token != null
                  ) {
                    this.checkToken(response.body.meta.authentication_token);
                  }
                }
                if (typeof response.body.errors[0].details != "object") {
                  alert(response.body.errors[0].details);
                } else {
                  let message = [];
                  for (var key in response.body.errors[0].details) {
                    message.push(response.body.errors[0].details[key]);
                  }
                  alert(message);
                }
              }
            );
        } catch (e) {
          alert(e.message);
        }
      } else {
        alert("Debes agregar requerimientos a este segmento");
      }
    },
    getCharacteristics(options) {
      if (options != null) {
        var characteristics = [options];
      } else {
        var characteristics = [];
      }
      try {
        const data = { company: { id: this.getCompany().id } };
        this.$http
          .post(
            "segments/company",
            { data: this.encrypt(data).toString() },
            {
              headers: {
                "X-Device-ID": this.getDeviceId(),
                Authorization: "Bearer " + this.getUserToken(),
              },
            }
          )
          .then(
            function (response) {
              let fullCharacteristics = response.body.data;
              fullCharacteristics.forEach(function (item) {
                characteristics.push({
                  id: item.id,
                  name: item.attributes.name,
                  maxRange: item.attributes.max_range,
                });
              });
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
            },
            function (response) {
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
              if (typeof response.body.errors[0].details != "object") {
                alert(response.body.errors[0].details);
              } else {
                let message = [];
                for (var key in response.body.errors[0].details) {
                  message.push(response.body.errors[0].details[key]);
                }
                alert(message);
              }
            }
          )
          .finally(function () {
            // cl characteristics
            this.myCharacteristicsOptions = characteristics;
          });
      } catch (e) {
        alert(e.message);
      }
    },
    searchCharacteristicValue(requirement) {
      var requirementData =
        requirement.characteristic_attributes.attribute_json.characteristic_id;
      var characteristicValues = [];
      var cent = false;
      const data = { company: { id: this.getCompany().id } };
      try {
        this.$http
          .get("segment_value/" + requirementData.id, {
            params: { data: data },
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken(),
            },
          })
          .then(
            function (response) {
              let fullValueCharacteristics = response.body.data;
              fullValueCharacteristics.forEach(function (item) {
                cent = true;
                requirement.characteristic_attributes.attribute_json.custom_querry[1] =
                  requirement.characteristic_attributes.attribute_json.characteristic_id.maxRange;
                characteristicValues.push({
                  id: item.id,
                  name: item.attributes.value.replace(/_/g, " "),
                  range: item.attributes.ranges,
                });
              });
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
            },
            function (response) {
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
              if (typeof response.body.errors[0].details != "object") {
                alert(response.body.errors[0].details);
              } else {
                let message = [];
                for (var key in response.body.errors[0].details) {
                  message.push(response.body.errors[0].details[key]);
                }
                alert(message);
              }
            }
          )
          .finally(function () {
            // cl characteristicValues
            if (
              cent &&
              characteristicValues[0].range &&
              characteristicValues[0].range.length > 0
            ) {
              characteristicValues.push({
                id: "0",
                name: "Consulta personalizada",
              });
            }
            requirement.characteristic_values_options = characteristicValues;
          });
      } catch (e) {
        alert(e.message);
      }
    },
    changeBooleanState(index, option) {
      var actual = this.requirements[index][option.boolean];
      this.requirements[index].requirement_query = false;
      this.requirements[index].requirement_range = false;
      this.requirements[index].requirement_email = false;
      this.requirements[index].requirement_birthday = false;
      this.requirements[index].requirement_register = false;
      this.requirements[index].requirement_redemption = false;
      this.requirements[index].requirement_characteristic = false;
      this.requirements[index][option.boolean] = !actual;
      if (!this.requirements[index][option.boolean]) {
        this.requirements[index].selectedOption = "";
      } else {
        this.requirements[index].selectedOption = option.text;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/views/conditions/New_condition.vue